module.exports = __webpack_public_path__ + "static/media/Snare808_1.398b69ed.wav";